import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Btn from "../common/Btn";

const AgreementDialog = ({ openDialog, onSaveAgreement }) => {
    const navigate = useNavigate();
  const [checkedItems, setCheckedItems] = useState([]);

  const datas = [
    { id: 1, title: "Agree to All", clickable: false },
    { id: 2, title: "[Required] Terms of Service", clickable: true, policyTab: "Terms of Service" }, // Required
    { id: 3, title: "[Required] Privacy Policy", clickable: true, policyTab: "Privacy Policy" }, // Required
    { id: 4, title: "[Required] Health Information Policy", clickable: true, policyTab: "Health Information Policy" }, // Required
    { id: 5, title: "[Optional] Marketing Communications", clickable: false },
    { id: 6, title: "[Optional] Receive Marketing Updates", clickable: false },
  ];

  const onViewPolicy = (policyTab) => {
    // Save state so we can return to the dialog after viewing policy
    // Note: We save the state that the user was viewing policies during signup
    // The EmailSignUp component will use localStorage to persist email/password
    // since those are already in its state when this function is called
    sessionStorage.setItem('returnToAgreementDialog', 'true');
    sessionStorage.setItem('signupStep', '2');
    sessionStorage.setItem('signupSubStep', '2');
    navigate('/policy', { state: { tab: policyTab, returnTo: '/emailsignup' } });
  };

  const onCheckAll = () => {
    if (checkedItems.includes(1)) {
      setCheckedItems([]);
    } else {
      const all = [];
      datas.forEach((one) => all.push(one.id));
      setCheckedItems([...all]);
    }
  };

  const onCheckOne = (one) => {
    if (checkedItems.includes(one)) {
      // Unchecking an item
      const arr = checkedItems.filter((el) => el !== one);
      // Also remove "Agree to All" (id: 1) if it was checked
      const finalArr = arr.filter((el) => el !== 1);
      setCheckedItems([...finalArr]);
    } else {
      // Checking an item
      const newCheckedItems = [...checkedItems, one];
      // Check if all individual items (2-6) are now checked
      const allIndividualChecked = [2, 3, 4, 5, 6].every(id => newCheckedItems.includes(id));
      if (allIndividualChecked && !newCheckedItems.includes(1)) {
        // Add "Agree to All" (id: 1)
        newCheckedItems.push(1);
      }
      setCheckedItems(newCheckedItems);
    }
  };

  return (
    <>
      <div
        className={
          "fixed left-0 z-20 h-[90vh] w-full flex-shrink-0 transform overflow-scroll rounded-t-[32px] bg-white px-6 py-[48px] text-center transition-all duration-300 " +
          (openDialog ? "bottom-0 translate-y-0" : "translate-y-full")
        }
      >
        <h1 className="mb-2 text-subtitle1">{"Terms and Conditions"}</h1>
        <p className="text-caption1_400 text-gray_180" dangerouslySetInnerHTML={{__html: "These items are required to use our service.<br />Please review all policies and terms before proceeding."}} />

        <ul className="mb-4 mt-[40px]">
          {datas.slice(0, 1).map((data) => (
            <li
              key={data.id}
              onClick={onCheckAll}
              className="flex justify-between py-6 border-b border-gray_80"
            >
              <h2 className="text-black text text-body1_600">{data.title}</h2>
              <img
                src={
                  checkedItems.includes(1)
                    ? `/images/mobile/icon/checkbox_circle_active.svg`
                    : `/images/mobile/icon/checkbox_circle.svg`
                }
                alt={"Checkbox"}
              />
            </li>
          ))}
          {datas.slice(1).map((data) => (
            <li
              key={data.id}
              className="flex justify-between py-6 items-center"
            >
              <div className="flex items-center gap-2 flex-1">
                <h2
                  className={`text-left text-black text-caption1_500 ${data.clickable ? 'cursor-pointer underline' : ''}`}
                  onClick={(e) => {
                    if (data.clickable) {
                      e.stopPropagation();
                      onViewPolicy(data.policyTab);
                    }
                  }}
                >
                  {data.title}
                </h2>
                {data.clickable && (
                  <img
                    src="/images/mobile/icon/arrow_right.svg"
                    alt="View"
                    className="w-4 h-4 cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      onViewPolicy(data.policyTab);
                    }}
                  />
                )}
              </div>
              <img
                src={
                  checkedItems.find((one) => one === data.id)
                    ? `/images/mobile/icon/checkbox_circle_active.svg`
                    : `/images/mobile/icon/checkbox_circle.svg`
                }
                alt={"Checkbox"}
                className="cursor-pointer"
                onClick={() => onCheckOne(data.id)}
              />
            </li>
          ))}
        </ul>
      </div>
      <Btn
        option={openDialog ? "bottom" : ""}
        bgColor={"bg-[#417FFF]"}
        textColor={"text-white"}
        borderColor={"border border-[#417FFF"}
        onAction={() => onSaveAgreement(checkedItems)}
        title={"Next"}
        innerClass={openDialog ? "" : "fixed bottom-0 translate-y-full "}
        active={
          checkedItems.includes(2) &&
          checkedItems.includes(3) &&
          checkedItems.includes(4)
            ? "on"
            : "ready"
        }
      />
    </>
  );
};

export default AgreementDialog;
